import React, { Component } from "react";
import Card from "react-bootstrap/Card";
import {
  Button,
  Container,
  Row,
  Col,
  Form,
} from "react-bootstrap";

import { connect } from "react-redux";
import { Dispatch } from "redux";
import "antd/dist/antd.css";
import { IWelcomeProps, IWelcomeState } from "../../interfaces/welcome";
import { IRootState } from "../../interfaces";
import { DatePicker } from "antd";
import moment from "moment";
import subscribeDateImage from "../../assets/images/Subscription_icon.png";
import checkinDateImage from "../../assets/images/CheckIn-SelectDateIcon.png";
import activityIcon from "../../assets/images/CheckIn-SelectActivityIcon.png";
import KPISectionIcon1 from "../../assets/images/Modules-Completed-Icon.png";
import KPISectionIcon2 from "../../assets/images/My-Attendance-Icon.png";
import KPISectionIcon3 from "../../assets/images/Quiz-Score-Icons.png";
import videoImageIcon from "../../assets/images/welcome.png";
import userJourney from "../../assets/images/userJourney.png";

import twoDayInternsiveTraining from "../../assets/images/2day-intensiveTraining.png";
import twoDayInternsiveTrainingGold from "../../assets/images/2day-intensiveTraining-shaded.png";
import onBoarding from "../../assets/images/onBoarding.png";
import onBoardingGold from "../../assets/images/onBoarding-shaded.png";

import projectAssign from "../../assets/images/project-assign.png";
import projectAssignGold from "../../assets/images/project-assign-shaded.png";

import activeWorking from "../../assets/images/active-working.png";
import activeWorkingGold from "../../assets/images/active-working-shaded.png";

import assessmentPass from "../../assets/images/assessment-pass.png";
import assessmentPassGold from "../../assets/images/assessment-pass-shaded.png";

import roleHolder from "../../assets/images/role-holder.png";
import roleHolderGold from "../../assets/images/role-holder-shaded.png";

import mentoring from "../../assets/images/mentoring.png";
import mentoringGold from "../../assets/images/mentoring-shaded.png";

import signedOff from "../../assets/images/signedOff.png";
import signedOffGold from "../../assets/images/signedOff-shaded.png";

import applyJobs from "../../assets/images/apply-jobs.png";
import applyJobsGold from "../../assets/images/apply-jobs-shaded.png";

import secureJob from "../../assets/images/secure-job.png";
import secureJobGold from "../../assets/images/secure-job-shaded.png";

import slideUp from "../../assets/images/slideUp.png";
import slideUpGold from "../../assets/images/slideUpGold.png";

import slideDown from "../../assets/images/slideDown.png";
import slideDownGold from "../../assets/images/slideDownGold.png";


import tipOfTheDayIcon from "../../assets/images/TipOfTheDay.png";
import playIcon from "../../assets/images/Play_Icon.png";
import { getCheckinDateRequest, checkInSubmitRequest, getMotivationRequest, getTopVideosRequest, getKPIModuleRequest, getKPIUserModuleRequest, getAttendanceRequest, getAverageScoreRequest} from '../../action';
import { topVideosReducer } from "../../reducer/TopVideos";
import { attendanceReducer } from "../../reducer/CheckIn";
import {moduleUserCountReducer, moduleCountReducer} from "../../reducer/Module";
import {avgQuizScoreReducer} from "../../reducer/QuizHistory";

import { AppRoutes, FrontendUrl } from "../../config";
import Loader from "../../components/Loader/Loader";
import noImage from "../../assets/images/no-image.png";
import Ribbon from "antd/lib/badge/Ribbon";
import { profileReducer } from "../../reducer/Profile";


const weekFormat = "DD/MM";
var disabledButtonsDailyCheckIn: any[] = [];
var disabledButtonsFacilitationCheckIn: any[] = [];
var weekDaysList: any[] = [];
var weekDates: any[] = [];
var attendanceTypeName: any[] = [
  "Daily Scrum",
  "Sprint Planning",
  "Backlog Refinement",
  "Knowledge Share",
  "Sprint Review",
  "Sprint Retrospective",
  "Training",
  "Backlog Refinement 2",

  "CoP Meeting",
  "Scrum of Scrum",
  "Ad-Hoc Meeting",
];

var endOfWeek = moment().endOf("week").toDate();
console.log(endOfWeek, ">>>>>>>>>>>>>>>>>>>End of Week");
let currentDate;
var nextDate: any;
// dates
// var currentTime = new Date();
// console.log(currentTime, "enddd")

// function disabledDate(current) {
//   // Can not select days before today and today
//   return current && current.valueOf() < Date.now();
// }

class Welcome extends Component<IWelcomeProps, IWelcomeState> {
  constructor(props: IWelcomeProps) {
    super(props);
    this.state = {
      CheckInDataFaciliation: [],
      checkDate: "",
      CheckInDataAttendance: [],
      DropDownValue: "",
      showSelectDate: "",
      SelectedDate: "",
      startDate: "",
      endDate: "",
      countdownDate: 0,
      datapickerToggle: false,
      topVideosList: [],
      changeCheckinIcons: false,
      completedModuleCount: 0,
      totalModuleCount: 0,
      attendanceData: 0,
      quizScoreData: 0,
      slideIndex: 0,
    };
  }

  // week days getter function
  getThisWeekDates = () => {
    for (var i = 1; i <= 6; i++) {
      weekDates.push(moment().day(i));
    }
    console.log("here here", weekDates);
    return weekDates;
  };

  checkboxValueIntializer = () => {
    for (let i = 0; i <= attendanceTypeName.length - 1; i++) {
      this.state.CheckInDataFaciliation[i] = 0;
      this.state.CheckInDataAttendance[i] = 0;
    }
  };

  pauseVideos = (indexNumber: any) => {
    var videosList = document.querySelectorAll("video");
      for(var i=0; i< videosList.length; i++) {
        var videonumber = document.getElementById("video"+i);
        if(videonumber?.play()) {
          videonumber?.pause();
          document.getElementById("middleCircle"+indexNumber)?.setAttribute("style", "display:block");      
        }
      }
  }

  showSlidesPrev = () => {
    var y = this.state.slideIndex;
    this.setState({ slideIndex: y});  
    this.showSlides(y-1);    
    this.pauseVideos(y);
  }

  showSlidesNext = () => {
    var x = this.state.slideIndex;
    this.setState({ slideIndex: x});  
    this.showSlides(x+1);
    this.pauseVideos(x);
  }

  showSlides = (n : number) => {
    let i;
    if(document.getElementsByClassName("mySlides")) {
      let slides = document.getElementsByClassName("mySlides");
      if(slides.length > 0) {
        if(n == 0) {
          document.getElementById("prevVideo")?.setAttribute("style", "display:none");  
          document.getElementById("nextVideo")?.setAttribute("style", "display:block");  
          this.setState({ slideIndex: 0 });
        } else if(n == slides.length)  {      
          document.getElementById("nextVideo")?.setAttribute("style", "display:none");  
          document.getElementById("prevVideo")?.setAttribute("style", "display:block");  
          this.setState({ slideIndex: slides.length });
  
        }
        else {          
          document.getElementById("nextVideo")?.setAttribute("style", "display:block");  
          document.getElementById("prevVideo")?.setAttribute("style", "display:block"); 
          this.setState({ slideIndex: n });
        }
        for (i = 0; i < slides.length; i++) {
        slides[i].setAttribute("style", "display:none");  
        }
        slides[n].setAttribute("style", "display:block");  
      }      
    }
  }

  componentDidMount() {
    this.getCountDate();
    this.setState({ checkDate: this.getCurrentDateString() });
    this.setState({ showSelectDate: "none" });    
    this.checkboxValueIntializer();

    var thisWeekDates: any = this.getThisWeekDates();

    weekDaysList = [];
    thisWeekDates.forEach((date: any) => {
      weekDaysList.push(date.format());
    });
    console.log("weeeeeeeeeeeeeeeeeeeeee", weekDaysList);

    const { getMotivationData, getTopVideos, getKPIModuleData, getKPIUserModuleData, getAttendancePercentage, getAverageScore } = this.props;
    console.log("-------------------------------",this.props)
    var startenddates = this.getMonday();
    const data = {
      startenddates,
    };
    console.log("startenddtes",data);
    getMotivationData(data);
    getTopVideos();
    getKPIModuleData();
    getKPIUserModuleData();
    getAttendancePercentage();
    getAverageScore();
    this.showSlides(0)
 }

  getNextMonday() {
    const now = new Date()
    const today = new Date(now)
    const nextMonday = new Date(today)

    do {
      nextMonday.setDate(nextMonday.getDate() + 1) // Adding 1 day
    } while (nextMonday.getDay() !== 1)

    console.log(nextMonday);
    return nextMonday;
  }

  getMonday() {    
    const format2 = "YYYY-MM-DD";
    var date2 = new Date();
    //var date2 = this.getNextMonday();
    
    var firstday = new Date(date2.setDate(date2.getDate() - date2.getDay() + 1)).toUTCString();
    var lastday = new Date(date2.setDate(date2.getDate() - date2.getDay() + 7)).toUTCString();
    

    let startDay = moment(firstday).format(format2);
    let endDay = moment(lastday).format(format2);
    return startDay+" : "+endDay;
  }

  dropDownHider = () => { 
    if(document.getElementById("AttendanceDropDownContainer")?.style.display === "none") {
      document.getElementById("AttendanceDropDownContainer")?.setAttribute("style","display:block");
    } else {
      document.getElementById("AttendanceDropDownContainer")?.setAttribute("style","display:none");
    }
    if(this.state.datapickerToggle) {
      this.setState({
        datapickerToggle: !this.state.datapickerToggle,
      });
    }
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>,num: number ) => {
    const { name, value, type } = event.target;
    if (type === "checkbox") {
      const { checked } = event.target;
      this.setState({
        ...this.state,
        [name]: checked,
      });
    } else {
      this.setState({
        ...this.state,
        [name]: value,
      });
    }    
    let eventStatus;
    let FacilitationeventStatus;
    if(name.indexOf("attendance") !== -1){
      eventStatus = (event.target.checked === true)  ? "1" : "0";
      for(let i=0; i<attendanceTypeName.length; i++) {
        if(i === num) {
          disabledButtonsDailyCheckIn[num] = eventStatus;
        } else {
          if(this.state.CheckInDataAttendance.length === 0) {
          disabledButtonsDailyCheckIn[i] = 0;
          } else {
            for(let j=0; j<this.state.CheckInDataAttendance.length; j++ ) {
              if(j !== num){
                disabledButtonsDailyCheckIn[j] = this.state.CheckInDataAttendance[j];
              }
            }              
          }
        }
      }
    this.setState({
      CheckInDataAttendance: disabledButtonsDailyCheckIn,
    });
    }
    if(name.indexOf("facilitate") !== -1){
      FacilitationeventStatus = (event.target.checked === true)  ? "1" : "0";
      for(let i=0; i<attendanceTypeName.length; i++) {
        if(i === num) {
          disabledButtonsFacilitationCheckIn[num] = FacilitationeventStatus;
        } else {
          if(this.state.CheckInDataFaciliation.length === 0) {
            disabledButtonsFacilitationCheckIn[i] = 0;
          }else {
            for(let j=0; j<this.state.CheckInDataFaciliation.length; j++ ) {
              if(j !== num){
              disabledButtonsFacilitationCheckIn[j] = this.state.CheckInDataFaciliation[j];
              }
            }
          }
        }
      }
    //console.log("disabledButtonsFacilitationCheckIn",disabledButtonsFacilitationCheckIn);
    this.setState({
      CheckInDataFaciliation: disabledButtonsFacilitationCheckIn,
    });  
    }    
  };

  getCurrentDateString = () => {
    const format2 = "YYYY-MM-DD";
    var date2 = new Date();

    let dateTime1 = moment(date2).format(format2);
    return dateTime1;
  };
  // SUBMIT BUTON CLICKED
  submitCheckIn = () => {  
    disabledButtonsDailyCheckIn = this.state.CheckInDataAttendance ;
    disabledButtonsFacilitationCheckIn = this.state.CheckInDataFaciliation ;   

    let facilitation = this.state.CheckInDataFaciliation;
    let attendance = this.state.CheckInDataAttendance;
    let checkDate = this.state.checkDate;
    let checkinType = this.state.DropDownValue;
    console.log(
      "facilitation\n" +
        facilitation +
        "\n" +
        "Daily Check In \n" +
        attendance +
        "\n" +
        "checkDate\n" +
        checkDate
    );
    let checkinTypeRef = 1;
    const { submitCheckInData } = this.props;

    const data = {
      facilitation,
      attendance,
      checkDate,
      checkinTypeRef    };
    
    submitCheckInData({ ...data });
    this.setState({ DropDownValue: "" });
  };
  closeDiv = () => {
    this.setState({ DropDownValue: "" });
    // console.log('i clickeddddddddddd')
  };

  getCountDate() {
    const msInDay = 24 * 60 * 60 * 1000;
    currentDate = Math.round(
      Math.abs(new Date().getTime() - new Date("2022-07-10").getTime()) /
        msInDay
    );
    this.setState({
      countdownDate: currentDate,
    });
    console.log("current Date--",currentDate);
  }

  getEventsDaywise = (date: any) => {  
    let selecteddate = date;
    let endDate = date;
    const { getCheckinDate } = this.props;
    console.log("-------------------------------",this.props)
    const data = {
      selecteddate,
    };
    this.setState({
      checkDate: date,
    });
    //console.log("selectedDay",data);
    getCheckinDate({ ...data });
  }

  componentDidUpdate(prevProps: IWelcomeProps) {
  const { checkInReducer} = this.props;
  const { checkInData } = checkInReducer;
  const {motivationReducer} = this.props;
  const {topVideosReducer} = this.props;
  const {moduleUserCountReducer} = this.props;
  const {moduleCountReducer} = this.props;
  const {moduleCount} = moduleCountReducer;
  const {moduleUserCount} = moduleUserCountReducer;
  const {attendanceReducer} = this.props;
  const {attendanceData} = attendanceReducer;
  const {avgQuizScoreReducer} = this.props;
  const {quizScoreData} = avgQuizScoreReducer;  

  if (prevProps.avgQuizScoreReducer !== this.props.avgQuizScoreReducer) {
    this.setState({quizScoreData: quizScoreData});  
  }  

  if (prevProps.attendanceReducer !== this.props.attendanceReducer) {
    this.setState({attendanceData: attendanceData});
  }
  console.log("attendance perentage data",this.state.attendanceData);

  if (prevProps.moduleCountReducer !== this.props.moduleCountReducer) {
    this.setState({totalModuleCount: moduleCount});
  }
  //console.log("KPI modules data"+this.state.totalModuleCount);

  if (prevProps.moduleUserCountReducer !== this.props.moduleUserCountReducer) {
    this.setState({completedModuleCount: moduleUserCount['countOfModules']});
  }
  //console.log("KPI modules user data"+this.state.completedModuleCount);

  if (prevProps.topVideosReducer !== this.props.topVideosReducer) {
    const {displayVideos} = topVideosReducer;
    //console.log("displayVideos", topVideosReducer.displayVideos.length);
    var topVideos = [];
    for(var i=0;i<topVideosReducer.displayVideos.length;i++) {
      //console.log("top videos",displayVideos[i]);     
        topVideos.push(displayVideos[i])
    }
    this.setState({topVideosList: topVideos});
  } 
  if(!this.state.changeCheckinIcons) {
    let element: HTMLElement = document.getElementsByClassName(
      "ant-picker-suffix"
    )[0] as HTMLElement;
    if (element) {
      element.style.display = "none";
    }

    let element1: HTMLElement = document.getElementsByClassName(
      "ant-picker-input"
    )[0] as HTMLElement;
    if (element1) {
      let img = document.createElement('img');
      img.src = checkinDateImage;
      img.setAttribute("width","15%");
      img.setAttribute("height","15%");
      img.className = "rightSpace calendar-img";
      element1.children[0].setAttribute("placeholder","Select Date");
      element1.insertBefore(img,element1.children[0]);
      this.setState({changeCheckinIcons:true})
    }
  }  

    if (
      motivationReducer &&
      motivationReducer.motivationData &&
      Object.entries(motivationReducer.motivationData).length && prevProps.motivationReducer !== this.props.motivationReducer
    ) {
      const { motivationData } = motivationReducer;
      //console.log("MondayMotivation", motivationData.motivation); 
    }

  if (prevProps.checkInReducer !== this.props.checkInReducer) {
    let attendanceArr;
    let facilitateArr;
    if ( !checkInReducer.isError &&
      checkInReducer &&
      checkInReducer.checkInData 
    ) { 
          attendanceArr = (checkInData.attendance).split(",");
          facilitateArr = (checkInData.facilitation).split(",");
          this.setState({
            CheckInDataAttendance: attendanceArr,            
            CheckInDataFaciliation: facilitateArr,
            DropDownValue: "DailyCheckIn",
          });
        /*}else {
          this.setState({
            DropDownValue: "",
            CheckInDataAttendance: [],
            CheckInDataFaciliation: [],
          });
        }   */ 
    } else if(checkInReducer.isError) {
      this.setState({
        DropDownValue: "",
        CheckInDataAttendance: [],
        CheckInDataFaciliation: [],
      });
    }
  }
  }

  playVideo = (indexNumber : any) => {
    if(document.getElementById("video"+indexNumber)) {
       var input = document.getElementById("video"+indexNumber);
        input?.setAttribute("style", "display:block");  
    }
    if(document.getElementById("img"+indexNumber)) {
      var imgInput = document.getElementById("img"+indexNumber);
      imgInput?.setAttribute("style", "display:none");  
   }
  var video1 = document.getElementById("video"+indexNumber);
      video1?.play();
      document.getElementById("middleCircle"+indexNumber)?.setAttribute("style", "display:none");      
  }

  getDailyCheckin = () => {
    window.location.href = "/student" + "/daily-check-in";
  }

  ChangeVideo = (item: any) => {
    let input = document.getElementById(`Viddeo-${item.id}`);
    if (input) {
      (input as HTMLVideoElement).pause()
    }
    this.props.history.push(
      AppRoutes.MY_VIDEOS_VIEW.replace(
        ":id",
        item.id,

      )
    )

  }



  render() { 
    const { motivationReducer, profileReducer} = this. props;
    const {profileInfo} = profileReducer;
    const { motivationData } = motivationReducer;
    return (
      <>
      <div className="main-section module-custom-main" id="right-container">
        <div className="container-new welcomeSection" >
          <div className="row check-in-row">
            <div className="col-8 check-in-col"> 
              <div className="row ">
                <h4>Let's check you in...</h4>
              </div>
              <div className="row">
              <div className="col-3 date-main">              
                  <DatePicker format="DD-MM-YY"
                    onClick={() => {
                      this.setState({
                        datapickerToggle: !this.state.datapickerToggle,
                      });
                    }}
                    onChange = {()=>{
                      this.setState({
                        datapickerToggle: !this.state.datapickerToggle,
                      });
                    }}
                    open={this.state.datapickerToggle}
                    disabledDate={(current) => {
                      // Can not select days after today and before start Date
                      const start = moment().subtract(1, "w");
                      return current < start || current > moment();
                    }}
                    style={{
                      background: "white",
                      width: "100%",
                      height: "44px",
                      borderRadius: "10px",
                      borderLeftWidth: 0,
                      borderRightWidth: 0,
                      borderTopWidth: 0,
                      border: "1px solid #CBA53C"
                    }}
                    onSelect={(date) => {
                      // console.log('date added',date.format("YYYY-MM-DD HH:mm:ss"))
                      console.log("Date Selected>>>", date);
                      this.setState({
                        checkDate: date.format("YYYY-MM-DD HH:mm:ss"),
                      });
                      this.setState({
                        SelectedDate: date.format("YYYY-MM-DD HH:mm:ss"),
                      });
                      this.dropDownHider();
                      this.getEventsDaywise(date.format("YYYY-MM-DD HH:mm:ss"));

                    }}
                  />
                </div>
                <div className="col-7 activity-main">
                  <div className="checkin-picker checkin-picker-focused" style={{background: "white", width: "100%", height: "44px", borderRadius: "10px",borderLeftWidth: "0px", borderRightWidth: "0px",borderTopWidth: "0px", marginLeft: "5px", border: "1px solid #CBA53C",width: "100%"}}
                                onClick={() => {
                                  this.dropDownHider();
                                  }}
                                >
                    <div className="checkin-picker-input">
                    <img src={activityIcon} alt=""
                    className="rightSpace calendar-img"
                    width="6%"
                    max-width='100%'
                    height="7%" />
                      <span style={{
                          background: "white",
                          width: "100%",
                          height: "44px",
                          borderRadius: "10px",
                          color: "#cec7c7",
                        }}
                      >Select Activity</span>                      
                    </div>
                  </div>
                  <div
                    style={{ marginLeft: "15px", display:"none" }}
                    id="AttendanceDropDownContainer"
                  >                              
                    <Row>
                      <Col>
                        <div className="Eventspopup">
                          <div>
                            <Row>
                              <Col
                                style={{
                                  float: "right",
                                  paddingLeft: "7px",
                                }}>
                                  <Row className="CheckInsection1" style={{marginLeft: "10px" , marginRight:"20px"}}>
                                    <Col lg={6}className="col-md-6 col-sm-6 col-6"  ></Col><Col lg={3} className="col-md-3 col-sm-3 col-3" style={{fontWeight:"bold"}}>Attended</Col><Col lg={3} className="col-md-3 col-sm-3 col-3" style={{fontWeight:"bold"}}>Facilitated</Col>
                                  </Row>                                
                              </Col> 
                            </Row>
                          </div>
                          {attendanceTypeName.map(
                            (item: any, index: any) => {
                              return (
                                <div>
                                  <Row>
                                    <Col
                                      style={{
                                        paddingRight: "0",
                                        paddingLeft: "7px",
                                      }}
                                    >
                                      <Row className="CheckInsection" style={{marginLeft: "10px" , marginRight:"20px"}}>
                                        <Col lg={6} className="col-md-6 col-sm-6 col-6"  >
                                          <span className="CheckInText">
                                            {item}
                                          </span>
                                        </Col>
                                        <Col lg={3} className="col-md-3 col-sm-3 col-3"  >                                                 
                                          <Form.Check
                                          custom
                                          type="checkbox"
                                          name={`attendance-${index}`}
                                          checked={ this.state.CheckInDataAttendance[index] === "1"? true : false }
                                          onChange={event => this.handleChange(event, index)}
                                          id={`attendance-${index}`}
                                          style={{paddingLeft:"2.5rem"}}
                                        />
                                        </Col>
                                        <Col lg={3} className="col-md-3 col-sm-3 col-3"  >  
                                        <Form.Check
                                          custom
                                          type="checkbox"
                                          name={`facilitate-${index}`}
                                          checked={ this.state.CheckInDataFaciliation[index] === "1"? true : false }
                                          onChange={event => this.handleChange(event, index)}
                                          id={`facilitate-${index}`}
                                          style={{paddingLeft:"2.5rem"}}
                                        />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </div>
                              );
                            }
                          )}
                        </div>                      
                      </Col>
                    </Row>
                                                            
                  </div>
                </div>
                <div className="col-2 check-btn">
                    <Button
                      disabled={this.state.SelectedDate === ""}
                      onClick={this.submitCheckIn}
                      id="checkinbtn"
                      style={{
                        //marginRight: "100px",
                        //marginTop: "5px",
                        color: "white",
                        background: "#c8a328",
                        borderColor: "#c8a328",
                        fontWeight: "bold",
                        borderRadius: "10px",
                        boxShadow: " 2px gray",
                        fontFamily: "Lokem-Headings-Robo",                            
                        marginLeft: "-12px",
                        height: "100%",
                        width: "50%",
                        position: "relative",
                        maxWidth: "100%",
                      }}
                      variant="warning"
                    >
                      <i className="fa fa-check" aria-hidden="true"></i>
                    </Button>
                </div>
              </div>
              </div>
              <div className="col-4 col-calendar">   
                  <img src={subscribeDateImage} alt=""
                    className="video-main cal-img"
                    width="20%"
                    max-width='100%'
                    height="auto" style={{position: "relative"}} />
                <div style={{display:"inline",verticalAlign: "middle",paddingLeft: "20px"}}>
                    <span className="countdown-section-days">{motivationData.remainSubscrDays}</span> <span className="daysColor" >days</span>
                </div>
                <div className="sub-text">
                  <span style={{color:"grey",fontSize:"12px"}}>Until your subscription ends</span>
                </div>
                <div className="renew-main">
                  <Button
                      style={{
                        marginTop: "3px",
                        color: "white",
                        background: "#c8a328",
                        borderColor: "#c8a328",
                        borderRadius: "5px",
                        boxShadow: " 2px gray",
                        fontFamily: "Lokem-Headings-Robo",  
                        fontSize: "10px",
                        width: "40%",                         
                      }}
                    >
                      RENEW NOW 
                    </Button>
              </div>
            </div>
          </div>
        </div> 
        {/*----- journey Map ---- */} 
        <div className="row usermapDiv">
          <div className="col tooltip1"> 
                <div className="row ">
                  <img src={profileInfo.journeyMapId >= 1 ? twoDayInternsiveTrainingGold : twoDayInternsiveTraining} alt="" className="userMapClass" />
                </div>
                <div className="row userMapTextDiv">
                  <span className="userMapText " >Two Day Intensive<br/>Training</span>
                </div>
                <span className="tooltiptext">Actively participate in the two day intensive by engaging in group tasks, creating notes and being 100% committed.</span>
          </div>
          <div className="col slideUpDiv">
            <img src={profileInfo.journeyMapId < 2 ? slideDown: slideDownGold} alt="" className="slideUpClass"/>
          </div>
          <div className="col tooltip2"> 
                <div className="row userMapTextDiv">
                  <span className="userMapText " >Onboarded into <br/>Pracctic & Teams</span>
                </div>
                <div className="row ">
                <img src={(profileInfo.journeyMapId >= 2) ? onBoardingGold : onBoarding} alt="" className="userMapClass" />
                </div>                
                <span className="tooltiptext1">Attend a formal meeting to learn more about your team members. Help to download and set up must have tools (Google Drive, agile tools etc)</span>
          </div>
          <div className="col slideUpDiv">
            <img src={profileInfo.journeyMapId < 3 ? slideUp : slideUpGold} alt="" className="slideUpClass"/>
          </div>
          <div className="col tooltip1"> 
                <div className="row">
                <img src={(profileInfo.journeyMapId >= 3) ? projectAssignGold : projectAssign} alt="" className="userMapClass" />
                </div>
                <div className="row userMapTextDiv">
                  <span className="userMapText " >Assigned to Project <br/> & Buddy</span>
                </div>
                <span className="tooltiptext">Introduce yourself and ask questions you may have. Complete Goal Setting tasks and hold yourself accountable.</span>
          </div>
          <div className="col slideUpDiv">
            <img src={profileInfo.journeyMapId < 4 ? slideDown : slideDownGold} alt="" className="slideUpClass"/>
          </div>
          <div className="col tooltip2"> 
                <div className="row userMapTextDiv">
                  <span className="userMapText " >Attendance &<br/>Facilitation</span>
                </div>
                <div className="row ">
                  <img src={(profileInfo.journeyMapId >= 4) ? activeWorkingGold: activeWorking} alt="" className="userMapClass" />
                </div>
                <span className="tooltiptext1">Attend events - Maintain a 90% - 95% average.Facilitate events - Maintain a 75% - 80% average</span>
          </div>
          <div className="col slideUpDiv">
            <img src={profileInfo.journeyMapId < 5 ? slideUp : slideUpGold} alt="" className="slideUpClass"/>
          </div>
          <div className="col tooltip1"> 
                <div className="row ">
                  <img src={(profileInfo.journeyMapId >= 5) ? assessmentPassGold: assessmentPass} alt="" className="userMapClass" />
                </div>
                <div className="row userMapTextDiv">
                  <span className="userMapText " style={{paddingLeft:"10px"}}>Pass Agile<br/>Assessments</span>
                </div>
                <span className="tooltiptext">Recommended assessments: PSM I, IIBA-AAC and PSPO I</span>
          </div>
          <div className="col slideUpDiv">
            <img src={profileInfo.journeyMapId < 6 ? slideDown : slideDownGold} alt="" className="slideUpClass"/>
          </div>          
          <div className="col tooltip2"> 
                <div className="row userMapTextDiv">
                  <span className="userMapText " style={{paddingLeft:"10px"}}>Become a<br/>Roleholder</span>
                </div>
                <div className="row ">
                  <img src={(profileInfo.journeyMapId >= 6) ? roleHolderGold: roleHolder} alt="" className="userMapClass" />
                </div>
                <span className="tooltiptext1">Apply for roles within Pracctic such as Scrum Master, Lead Scrum Master, Business Analyst and Product Owner</span>
          </div>
          <div className="col slideUpDiv">
            <img src={profileInfo.journeyMapId < 7 ? slideUp: slideUpGold} alt="" className="slideUpClass"/>
          </div>
          <div className="col tooltip1"> 
                <div className="row ">
                  <img src={(profileInfo.journeyMapId >= 7) ? mentoringGold : mentoring} alt="" className="userMapClass" />
                </div>
                <div className="row userMapTextDiv">
                  <span className="userMapText " style={{paddingLeft:"10px"}}>Start<br/>mentoring</span>
                </div>
                <span className="tooltiptext">Allocate yourself to a mentor - list of names and their offers will be provided. CV prep</span>
          </div>
          <div className="col slideUpDiv">
            <img src={profileInfo.journeyMapId < 8 ? slideDown : slideDownGold} alt="" className="slideUpClass"/>
          </div>  
          <div className="col tooltip2"> 
                <div className="row userMapTextDiv">
                  <span className="userMapText " style={{paddingLeft:"10px"}}>Signed off for<br/>job search</span>
                </div>
                <div className="row ">
                  <img src={(profileInfo.journeyMapId >= 8) ? signedOffGold : signedOff} alt="" className="userMapClass" />
                </div>
                <span className="tooltiptext1">Once ready, PMO will sign you off and you are now ready to start applying for jobs.</span>
          </div>
          <div className="col slideUpDiv">
            <img src={profileInfo.journeyMapId < 9 ? slideUp: slideUpGold} alt="" className="slideUpClass"/>
          </div>  
          <div className="col tooltip1"> 
                <div className="row ">
                  <img src={(profileInfo.journeyMapId >= 9) ? applyJobsGold: applyJobs} alt="" className="userMapClass" />
                </div>
                <div className="row userMapTextDiv">
                  <span className="userMapText " style={{paddingLeft:"10px"}}>Start applying<br/>for jobs</span>
                </div>
                <span className="tooltiptext">Sign up for different recruitment websites - Linkedin, Total Jobs, Reed and Indeed</span>
          </div> 
          <div className="col slideUpDiv">
            <img src={profileInfo.journeyMapId < 10 ? slideDown: slideDownGold} alt="" className="slideUpClass"/>
          </div> 
          <div className="col tooltip2"> 
                <div className="row userMapTextDiv">
                  <span className="userMapText " style={{paddingLeft:"10px"}}>Secure a job!</span>
                </div>
                <div className="row ">
                  <img src={(profileInfo.journeyMapId == 10) ? secureJobGold : secureJob} alt="" className="userMapClass" />
                </div>
                <span className="tooltiptext1">Apply the skills gained on the platform in your new career. Success stories are always welcomed.</span>
          </div>          
        </div>   
        
        
        <div className="container-new KPISection" style={{float:"left"}}>
          <div className="row1" >
            <div className="col KPISection1">
              <div className="KPISection1Left">
              <img src={KPISectionIcon1} alt=""
                  className="KPIImage1Rotate"
                  max-width='100%'
                  height="100px" />
              </div>
              <div className="KPISection1Right">                    
                <div className="KPISection1UpperText">
                  Modules Completed
                </div>
                <div className="KPISection1Text">
                 {this.state.completedModuleCount}/{this.state.totalModuleCount}
                </div>
              </div>
            </div>
            
            <div className="col KPISection1" id="attendanceKPI" onClick={this.getDailyCheckin}>
              <div className="KPISection1Left">
              <img src={KPISectionIcon2} alt=""
                  className="KPIImage1 KPIImageMargin"
                  max-width='100%'
                  height="140px" />
              </div>
              <div className="KPISection1Right">                    
                <div className="KPISection1UpperText">
                My Attendance
                </div>
                <div className="KPISection1Text">
                {this.state.attendanceData}%
                </div>
              </div>
            </div>
            
            <div className="col KPISection1" >
              <div className="KPISection1Left3">
              <img src={KPISectionIcon3} alt=""
                  className="KPIImage3 KPIImageMargin1"
                  max-width='100%'
                  height="140px" />
              </div>
              <div className="KPISection1Right">                    
                <div className="KPISection1UpperText">
                My Average Quiz Score
                </div>
                <div className="KPISection1Text">
                {this.state.quizScoreData === null ? 0 : this.state.quizScoreData}%
                </div>
              </div>
            </div>
          </div>
        </div>  
        <div className="container-new TipOfDayVideosSection" >
          <div className="row1">
            <div className="col TipOfTheDay">
              <div className="tipTitle">
                Tip of the Week
              </div>
                <img src={tipOfTheDayIcon} alt=""
                    style={{float:"left",position:"relative"}}
                    max-width='100%'
                    width='30%'
                    height="auto" />
              <div className="tipContent" style={{float:"left",width:"70%"}}>
                <div className="tipContentBox">
                  <div className="tipContentTitle">
                  {motivationData.title}
                  </div>
                  <div className="tipContentDes">
                  {motivationData.description}
                  </div>
                </div>  
              </div>
            </div>
            <div id="trend" className="col videoSection">
              <div className="videoTitle">
                <a className="prevVideo" id="prevVideo" onClick={() => {
                                  this.showSlidesPrev();
                                }} style={{display:"none"}}><i className="fas fa-chevron-circle-left leftArrow"></i></a>
                  Trending Videos
                <a className="nextVideo" id="nextVideo"onClick={() => {
                                  this.showSlidesNext();
                                }}><i className="fas fa-chevron-circle-right rightArrow"></i></a>
              </div>
              <div className="slideshow-container">
                {!this.state.topVideosList  ? (
                      <Loader />
                    ) : (  
                      this.state.topVideosList.map((item: any, index: any) => ( 
                          item.thumbnailUrl ? (
                            <div className="mySlides fade" >
                              <video id={`video${index}`} controlsList="nodownload" 
                              controls
                              autoPlay={false}
                              playsInline
                              src={`${FrontendUrl}${item.url}`}
                              style={{objectFit:"cover", boxSizing: "initial", borderRadius: "5px", width:"100%", display:"none"}}
                              poster={`${FrontendUrl}${item.thumbnailUrl}`}></video>
                            <img id={`img${index}`} src={`${FrontendUrl}${item.thumbnailUrl}`} style={{width:"100%"}}  />
                            <a className="playVideo" id={`playVideo${index}`}><img src={playIcon} alt=""
                              className="dot middleCircle"  id={`middleCircle${index}`} onClick={() => {
                                this.playVideo(index);
                              }} max-width='100%' /></a>
                              <div className="videoName">
                                {item.title}
                              </div>
                              <div className="videoDesc">
                                {item.description}
                              </div>
                          </div>
                          ) : (
                            <img src={noImage} alt=""
                            className="demo cursor"
                            style={{borderRadius: "5px",width:"100%"}}
                            />
                          )
                  ))
                )}           
              </div>            
            </div>
          </div>
        </div> 
        
      </div>              
      </>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  checkInReducer: state.checkInReducer,
  motivationReducer: state.motivationReducer,
  topVideosReducer: state.topVideosReducer,
  moduleCountReducer: state.moduleCountReducer,
  moduleUserCountReducer: state.moduleUserCountReducer,
  attendanceReducer: state.attendanceReducer,
  avgQuizScoreReducer: state.avgQuizScoreReducer,
  profileReducer: state.profileReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    submitCheckInData: (data: any) => {
      dispatch(checkInSubmitRequest(data));
    },   
    getCheckinDate: (data: any) => {
      dispatch(getCheckinDateRequest(data));
    },
    getMotivationData: (data: any) => {
      dispatch(getMotivationRequest(data));
    },
    getTopVideos: () => {
      dispatch(getTopVideosRequest());
    },
    getKPIModuleData: () => {
      dispatch(getKPIModuleRequest());
    },
    getKPIUserModuleData: () => {
      dispatch(getKPIUserModuleRequest());
    },
    getAttendancePercentage: () => {
      dispatch(getAttendanceRequest());
    },
    getAverageScore: () => {
      dispatch(getAverageScoreRequest());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
